import { CommonModule } from '@angular/common';
import {  ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';
import { TimePickerComponent } from './timepicker.component';
import { LocaleConfig, LOCALE_CONFIG } from './timepicker.config';
import { LocaleService } from './locale.service';

@NgModule({
  declarations: [
    TimePickerComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ],
  providers: [],
  exports: [
    TimePickerComponent
  ],
  // entryComponents: [
  //   TimePickerComponent
  // ]
})
export class TimePickerModule {
  constructor() {
  }
  static forRoot(config: LocaleConfig = {}): ModuleWithProviders<TimePickerModule> {
    return {
      ngModule: TimePickerModule,
      providers: [
        { provide: LOCALE_CONFIG, useValue: config},
        { provide: LocaleService, useClass: LocaleService, deps: [LOCALE_CONFIG]}
      ]
    };
  }
}
